var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeFillIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7087 7.62506C15.7837 4.60006 12.967 2.8584 10.0003 2.8584C8.51699 2.8584 7.07533 3.29173 5.75866 4.10007C4.44199 4.91673 3.25866 6.1084 2.29199 7.62506C1.45866 8.9334 1.45866 11.0584 2.29199 12.3667C4.21699 15.4001 7.03366 17.1334 10.0003 17.1334C11.4837 17.1334 12.9253 16.7001 14.242 15.8917C15.5587 15.0751 16.742 13.8834 17.7087 12.3667C18.542 11.0667 18.542 8.9334 17.7087 7.62506ZM10.0003 13.3667C8.13366 13.3667 6.63366 11.8584 6.63366 10.0001C6.63366 8.14173 8.13366 6.6334 10.0003 6.6334C11.867 6.6334 13.367 8.14173 13.367 10.0001C13.367 11.8584 11.867 13.3667 10.0003 13.3667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.61621C8.69167 7.61621 7.625 8.68288 7.625 9.99954C7.625 11.3079 8.69167 12.3745 10 12.3745C11.3083 12.3745 12.3833 11.3079 12.3833 9.99954C12.3833 8.69121 11.3083 7.61621 10 7.61621Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFillIcon);
export default __webpack_public_path__ + "static/media/eye-fill-icon.152c890ff5a83c2491fb2fbb0d1fa674.svg";
export { ForwardRef as ReactComponent };